/**
 * A scorecard is considered "bluelabel" if it is for an internal Reviewtrackers account (salesbot or marketing).
 * This is determined if
 *   - a custom logo hasn't been uploaded (so RT logo will be used)
 *   - the contact email is a reviewtrackers email.
 */
export function isBlueLabel (results) {
  const contactEmail = results.contact_email || ''
  return !results.logo_url || contactEmail.includes('reviewtrackers')
}